export default {
      id: "method-usage",
      viewBox: "0 0 49 51",
      url: "/dist/svg/" + "sprite.svg#method-usage",
      toString: function () {
        return this.url;
      }
    }